import PropTypes from "prop-types";
import React from "react";

import DateFormatingService from "services/DateFormatingService";
import LatestNewsService from "services/LatestNewsService";

import TimelineItem from "./TimelineItem";

class TimelineMonth extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      newItems: [],
    };
  }

  componentDidMount = () => {
    const { allowPolling } = this.props;

    this.loadMonth();

    if (allowPolling) {
      setInterval(() => {
        this.checkForUpdates();
      }, 10 * 1000);
    }
  };

  loadMonth = async () => {
    const { month } = this.props;

    let items = await LatestNewsService.getLatestNewsByMonth(month);

    items = items.sort((a, b) => parseInt(b.created) - parseInt(a.created));

    this.setState({
      items,
    });
  };

  checkForUpdates = async () => {
    const { month } = this.props;

    const newItems = await LatestNewsService.getLatestNewsByMonth(month);

    this.setState({
      newItems,
    });
  };

  showUpdates = () => {
    this.setState((prevState) => {
      return {
        items: prevState.newItems,
      };
    });
  };

  renderShowUpdates = () => {
    const { items, newItems } = this.state;

    const updates = newItems.length - items.length;

    if (updates <= 0) {
      return null;
    }

    const buttonText =
      updates === 1 ? (
        <span className="btn__text">
          Toon <span>1 nieuwe update</span>
        </span>
      ) : (
        <span className="btn__text">
          Toon de <span>{updates} nieuwe updates</span>
        </span>
      );
    return (
      <button
        className="btn btn--reload is-outline is-small is-spaced"
        type="button"
        onClick={this.showUpdates}
      >
        <svg className="btn__icon is-prefix" width="18px" height="20px">
          <use xlinkHref="#reload" width="18px" height="20px" />
        </svg>
        {buttonText}
      </button>
    );
  };

  renderTitle = () => {
    const { month } = this.props;

    return (
      <h2 className="title">
        {DateFormatingService.formatToLongDateMonth(month)}
      </h2>
    );
  };

  render = () => {
    const { items } = this.state;

    return (
      <div className="timeline-month">
        {this.renderShowUpdates()}
        {this.renderTitle()}
        {items.length === 0 && (
          <p className="timeline__empty">Er is geen nieuws voor deze maand.</p>
        )}
        {items.map((item) => (
          <TimelineItem item={item} />
        ))}
      </div>
    );
  };
}

TimelineMonth.propTypes = {
  month: PropTypes.number.isRequired,
  allowPolling: PropTypes.bool.isRequired,
};

export default TimelineMonth;
